// import React from "react";
// import {
//   FaPlaneArrival,
//   FaPlaneDeparture,
//   FaTaxi,
//   FaBriefcase,
//   FaCarSide,
// } from "react-icons/fa";

// const categories = [
//   {
//     name: "Airport Pickup",
//     icon: <FaPlaneArrival />,
//   },

//   {
//     name: "Outstation Taxi",
//     icon: <FaTaxi />,
//   },
//   {
//     name: "Corporate Travel",
//     icon: <FaBriefcase />,
//   },
//   {
//     name: "Luxury Cab",
//     icon: <FaCarSide />,
//   },
//     {
//     name: "Airport Drop",
//     icon: <FaPlaneDeparture />,
//   },
// ];

// const CategorySection = () => {
//   return (
//     <section className="cate--layout5">
//       <div className="container">
//         <div
//           className="cate__box"
//           style={{
//             backgroundImage: "url('/img/shape/cate-bg.png')",
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//           }}
//         >
//           <div className="row">
//             <div className="col-lg-12 mx-auto">
//               <div className="title-area white-title text-center">
//                 <span className="sec-subtitle">
//                   Mumbai Airport Cab Services
//                 </span>
//                 <h2 className="sec-title h1 text-white">
//                   Choose Your Cab Service
//                 </h2>
//               </div>
//             </div>
//           </div>

//           <div className="cate__list">
//             {categories.map((category, index) => (
//               <a
//                 key={index}
//                 className="cate-block"
//                 href="/services"
//               >
//                 <i
//                   className="cate-block__icon"
//                   style={{
//                     fontSize: "50px",
//                     color: "#1A4160",
//                   }}
//                 >
//                   {category.icon}
//                 </i>

//                 <span>{category.name}</span>
//               </a>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CategorySection;


import React from "react";
import {
  FaPlaneArrival,
  FaPlaneDeparture,
  FaTaxi,
  FaBriefcase,
  FaCarSide,
} from "react-icons/fa";

const categories = [
  {
    name: "Airport Pickup",
    icon: <FaPlaneArrival />,
  },
  {
    name: "Outstation Taxi",
    icon: <FaTaxi />,
  },
  {
    name: "Corporate Travel",
    icon: <FaBriefcase />,
  },
  {
    name: "Luxury Cab",
    icon: <FaCarSide />,
  },
  {
    name: "Airport Drop",
    icon: <FaPlaneDeparture />,
  },
];

const CategorySection = () => {
  return (
    <section className="cate--layout5 py-5">
      <div className="container">
        <div
          className="cate__box"
          style={{
            background: "linear-gradient(135deg, #1F365C, #294A7A)",
            borderRadius: "20px",
            padding: "60px 30px",
          }}
        >
          {/* Title */}
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="title-area text-center mb-5">
                <span
                  className="sec-subtitle"
                  style={{
                    color: "#D8A33A",
                    fontWeight: "600",
                  }}
                >
                  Mumbai Airport Cab Services
                </span>

                <h2 className="sec-title h1 text-white">
                  Choose Your Cab Service
                </h2>

                <p
                  style={{
                    color: "#d9d9d9",
                    maxWidth: "700px",
                    margin: "0 auto",
                  }}
                >
                  Safe, reliable, and affordable airport transportation
                  solutions tailored for your travel needs.
                </p>
              </div>
            </div>
          </div>

          {/* Categories */}
          <div className="row justify-content-center">
            {categories.map((category, index) => (
              <div
                key={index}
                className="col-lg-2 col-md-2 col-sm-4 col-6 mb-4"
              >
                <a
                  href="/services"
                  className="d-block text-center text-decoration-none"
                  style={{
                    background: "rgba(255,255,255,0.08)",
                    padding: "25px 15px",
                    borderRadius: "15px",
                    transition: "0.3s",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      fontSize: "50px",
                      color: "#D8A33A",
                      marginBottom: "15px",
                    }}
                  >
                    {category.icon}
                  </div>

                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "600",
                      fontSize: "15px",
                    }}
                  >
                    {category.name}
                  </span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategorySection;